import type { ReactNode } from 'react';
import { Suspense } from 'react';
import { NarrativeCommunityListSkeleton } from './NarrativeCommunityListSkeleton';

type Props = {
  children: ReactNode;
};

export const NarrativeCommunityListLoader = ({ children }: Props) => {
  return (
    <Suspense fallback={<NarrativeCommunityListSkeleton />}>
      {children}
    </Suspense>
  );
};
